module.exports = __webpack_public_path__ + "img/public/AdminIcons/ce2b5b26.svg?c13e2443";